import { Link } from "react-router-dom";
import { LegalLinks } from "@jkast90/kast-common/legal/react";
import { useSession, useSignedIn } from "@jkast90/kast-common/auth";
import { Button, ThemePicker } from "@jkast90/kast-common/ui";
import { signIn, signOut } from "@common/auth/session";
import { themeStore } from "../theme";

/** The quiet end of the page: the small print, the theme and, out of the way, sign-in. */
export default function Footer() {
  const { user } = useSession();
  const signedIn = useSignedIn();
  return (
    <footer className="footer">
      <span className="muted small">Salvagers is a board game by Jake. Art is human-drawn.</span>
      <div className="muted small footer-legal">
        <LegalLinks separator=" · " newTab={false} />
        {" · "}
        <Link to="/bug-report">Report a bug</Link>
      </div>
      <div className="muted small check">
        <span aria-hidden="true">Theme</span>
        <ThemePicker store={themeStore} size="sm" />
      </div>
      <span className="muted small footer-session">
        {signedIn && user ? (
          <>
            <Link to="/account">{user.email}</Link>
            {" · "}
            <Button variant="link" onClick={() => void signOut()}>
              Sign out
            </Button>
          </>
        ) : (
          <Button variant="link" onClick={signIn}>
            Sign in
          </Button>
        )}
      </span>
    </footer>
  );
}
